<!-- 油卡管理 -->
<template>
<div>
  <van-pull-refresh style="padding: 10px 15px;" v-model="down_loading" @refresh="get_data">
    <van-empty v-if="data.length == 0" description="请办理或绑定油卡" />
    <span v-else>
      <cardT v-for="(val, key) in data" :key="key" :data="val" @click.native="on(val)" />
      <div style="height: 130px">
        <van-divider dashed>点击油卡进行管理</van-divider>
      </div>
    </span>
  </van-pull-refresh>

  <div class="footer">
    <van-button style="margin-bottom: 10px;" v-if="v_card_num < 2" round block type="info"  @click="show('reg')">办理油卡</van-button>
    <van-button round block type="info"  @click="show('into_del', {type: 1})">绑定油卡</van-button>
  </div>

  <!-- 油卡操作 -->
  <van-action-sheet v-model="show_on" :actions="options" cancel-text="取消" round close-on-click-action @select="select" />

  <!-- 子组件 -->
  <reg ref="reg" @up_data="get_data" />
  <intoDel ref="into_del" @up_data="get_data" />
  <recharge ref="recharge" @up_data="get_data" @show_msg="show_msg" />
  <bill ref="bill" />
  <inte ref="inte" />
  <msg ref="msg" @up_data="get_data" />
</div>
</template>

<script>
import cardT from '@/components/card/card_template'
import reg from '@/components/card/reg'
import intoDel from '@/components/card/into_del'
import recharge from '@/components/card/recharge'
import bill from '@/components/card/bill'
import inte from '@/components/card/inte'
import msg from '@/components/card/msg'

export default {
  name: 'card',
  components: {cardT, reg, intoDel, recharge, bill, inte, msg},
  data () {
    return {
      down_loading: false,
      show_on: false,
      options: [],
      data: [],
      on_data: {},
      if_re: '',
      v_card_num: 0 // 虚拟卡数量
    }
  },

  created () {
    this.get_data()
  },

  methods: {

    // 显示子组件
    show (fname, data = null) {
      this.$refs[fname].show(data)
    },

    // 显示编辑信息
    show_msg (data) {
      this.$refs.msg.show(data)
    },

    // 获取数据
    get_data () {
      this.ax(this, 'sel_web_card_user', {}, (res) => {
        if (res.err_num === 0) {
          this.down_loading = false
          this.data = res.data.card_data
          this.if_re = res.data.if_recharge

          this.data.forEach((card) => {
            if (card.chip_id === null) {
              this.v_card_num++
            }
          })
        }
      }, 'all')
    },

    // 选择油卡
    on (data) {
      // 判断油卡状态
      if (data.status !== 0) {
        return this.$notify({ type: 'danger', message: '该卡已停用，请联系油站管理员' })
      }

      this.show_on = true
      this.on_data = data
      let options = [
        {type: 'bill', name: '消费记录'},
        {type: 'inte', name: '积分记录'}
      ]
      if (this.if_re) {
        options.unshift({type: 'recharge', name: '充值油卡'})
      }
      if (!data.chip_id) {
        options.push({type: 'msg', name: '编辑资料'})
      }
      if (!data.default && !data.msg.IC_CardID) {
        options.push({type: 'default', name: '设为默认'})
      }
      if (data.chip_id) {
        options.push({type: 'into_del', name: '解除绑定'})
      }

      // 是否启用充值功能
      if (!this.$root.systemFun.recharge) {
        options.splice(0, 1)
      }

      this.options = options
    },

    // 选中操作
    select (val) {
      if (val.type === 'recharge') {
        this.$refs.recharge.show(this.on_data)
      }
      if (val.type === 'bill') {
        this.$refs.bill.show(this.on_data)
      }
      if (val.type === 'inte') {
        this.$refs.inte.show(this.on_data)
      }
      if (val.type === 'msg') {
        this.$refs.msg.show(this.on_data)
      }
      if (val.type === 'default') {
        this.default()
      }
      if (val.type === 'into_del') {
        this.$refs.into_del.show({type: 2, data: this.on_data})
      }
      this.ifShow = false
    },

    // 设位默认
    default () {
      let that = this
      this.$dialog({
        title: '将 (' + this.on_data.card_no + ') 设为默认油卡',
        message: '设为默认后在使用时会自动选择，个人中心以该卡为依据显示会员等级、余额、积分等',
        showCancelButton: true,
        messageAlign: 'left'
      }).then(() => {
        that.ax(that, 'def_web_card_user', {card_id: that.on_data.card_id}, (res) => {
          if (res.err_num === 0) {
            that.get_data()
            that.$notify({ type: 'success', message: res.msg })
          }
        })
      }).catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/card/card.vue